import gql from 'graphql-tag';
const UPDATE_HASHED_EMAIL_LIST = gql`
  mutation updateHashedEmailList(
    $id: ID!
    $activated: Boolean
    $stepProgress: Int
    $status: EnumFirstPartyDataStatus
    $dsp: EnumFirstPartyDataDSP
    $tag: String
  ) {
    updateHashedEmailList(
      where: { id: $id }
      data: {
        activated: $activated
        stepProgress: $stepProgress
        status: $status
        dsp: $dsp
        tag: $tag
      }
    ) {
      id
      name
      stepProgress
      status
      dsp
      typeOfFirstPartyData
      tag
    }
  }
`;

export default UPDATE_HASHED_EMAIL_LIST;
